"use client";

import React, { createContext, useContext } from "react";
import { useTina } from "@/utils";

const TinaGlobalContext = createContext<any>(null);

export function TinaGlobalProvider({
  globalData,
  children,
}: {
  globalData: any;
  children: React.ReactNode;
}) {
  // Single useTina call for global data
  const { data } = useTina({
    query: globalData.query,
    variables: globalData.variables,
    data: globalData.data,
  });

  return (
    <TinaGlobalContext.Provider value={data?.global || null}>
      {children}
    </TinaGlobalContext.Provider>
  );
}

export function useGlobalData() {
  const context = useContext(TinaGlobalContext);
  if (context === undefined) {
    throw new Error("useGlobalData must be used within TinaGlobalProvider");
  }
  return context;
}
